import { render, staticRenderFns } from "./SubscriptionTypeEdit.vue?vue&type=template&id=2fbae54e&scoped=true"
import script from "./SubscriptionTypeEdit.vue?vue&type=script&lang=js"
export * from "./SubscriptionTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTypeEdit.vue?vue&type=style&index=0&id=2fbae54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbae54e",
  null
  
)

export default component.exports